import React, { Component } from "react";
import {
  CustomInput,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  // Input,
  Label,
} from "reactstrap";
import { Formik, Field, Form } from "formik";

import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from "draft-js";

// import Select from "react-select";
// import CustomSelectInput from "../../../../../../components/common/CustomSelectInput";
import IntlMessages from "../../../../../../helpers/IntlMessages";

import { Blog } from "../../../../../../api/Api";

export default class EditConstant extends Component {
  state = {
    editorState: EditorState.createWithContent(
      ContentState.createFromBlockArray(
        convertFromHTML(this.props.product.content)
      )
    ),
    loading: false,
    picture: "",
    file: "",
    imagePreviewUrl: "",
    initialValues: {
      title: this.props.product.title,
      description: this.props.product.description,
      picture: "",
    },
  };

  handleChange = async ({ target }) => {
    try {
      let file = target.files[0],
        src = target.value;

      this.setState({ file, src });
    } catch (error) {}
  };

  handleSubmit = async (values, { resetForm, setSubmitting, setValues }) => {
    this.setState({ loading: true });
    try {
      let newValues = {
        ...values,
        content: draftToHtml(
          convertToRaw(this.state.editorState.getCurrentContent())
        ),
        // cover: this.state.file,
      };
      // console.log(newValues);
      await Blog.editBlog(newValues, this.props.product.id);

      //closing addNew Component
      this.props.toggleModal();

      //fetching data from dataBase
      this.props.dataListRender();

      // if (!this.state.isNew) {
      //   Swal.close();
      // }
      resetForm();
    } catch (error) {
      console.error(error);
      // toast(error.response.data.message);
    }
    this.setState({ loading: false });
  };
  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
  };
  handleChange = async ({ target }) => {
    try {
      let file = target.files[0],
        src = target.value;
      var reader = new FileReader();
      reader.onloadend = () => {
        this.setState({
          file,
          imagePreviewUrl: reader.result,
        });
      };
      reader.readAsDataURL(file);

      this.setState({ file, src });
    } catch (error) {}
  };
  render() {
    const { editorState } = this.state;
    return (
      <>
        <Modal
          isOpen={this.props.modalOpen}
          toggle={this.props.toggleModal}
          wrapClassName="modal-right"
          backdrop="static"
        >
          {this.state.loading ? <div className="loading" /> : ""}
          <ModalHeader toggle={this.props.toggleModal}>
            <IntlMessages id="pages.edit-new-modal-blog" />
          </ModalHeader>
          <ModalBody>
            <Formik
              initialValues={this.state.initialValues}
              // validationSchema={this.ValidationSchema}
              onSubmit={this.handleSubmit}
            >
              {(props) => (
                <Form className="form" onSubmitCapture={props.handleSubmit}>
                  <Label className="mt-4">
                    <IntlMessages id="title" />
                  </Label>
                  <Field
                    name="title"
                    placeholder="تیتر  "
                    className="form-control"
                    type="text"
                    required
                  />
                  <Label className="mt-4">
                    <IntlMessages id="توضیحات" />
                  </Label>
                  <div>
                    <Editor
                      editorState={editorState}
                      wrapperClassName="demo-wrapper"
                      editorClassName="demo-editor"
                      onEditorStateChange={this.onEditorStateChange}
                    />
                    {/* <textarea
                        disabled
                        value={draftToHtml(
                          convertToRaw(editorState.getCurrentContent())
                        )}
                      /> */}
                  </div>
                  <Label className="mt-4">
                    <IntlMessages id="description" />
                  </Label>
                  <Field
                    name="description"
                    placeholder="توضیحات  "
                    className="form-control"
                    type="text"
                    required
                  />
                  {/* <div className="custom-file">
                    <Field
                      name="cover"
                      placeholder="عکس"
                      className="custom-file-input"
                      type="file"
                      onChange={(e) => this.handleChange(e)}
                      accept="image/*"
                    />

                    <label
                      className="custom-file-label"
                      htmlFor="inputGroupFile01"
                    >
                      {this.state.src}
                    </label>
                    {this.state.imagePreviewUrl ? (
                      <img
                        style={{ width: "300px", marginTop: "20px" }}
                        src={this.state.imagePreviewUrl}
                      />
                    ) : (
                      ""
                    )}
                  </div> */}

                  <ModalFooter>
                    <div style={{ marginTop: "100px" }}>
                      <Button
                        color="secondary"
                        outline
                        onClick={this.props.toggleModal}
                      >
                        <IntlMessages id="pages.cancel" />
                      </Button>
                      <Button color="primary" type="submit">
                        <IntlMessages id="pages.submit" />
                      </Button>
                    </div>
                  </ModalFooter>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </Modal>
      </>
    );
  }
}
